import { render, staticRenderFns } from "./DefaultFolding.vue?vue&type=template&id=a724edac&scoped=true&"
import script from "./DefaultFolding.vue?vue&type=script&lang=js&"
export * from "./DefaultFolding.vue?vue&type=script&lang=js&"
import style0 from "./DefaultFolding.vue?vue&type=style&index=0&id=a724edac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a724edac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VContainer,VRow,VSkeletonLoader,VSwitch,VTooltip})
